import React, { useState, useEffect } from "react";

import useBookState from "./useBookState.ts";
import useAuthState from "../auth/useAuthState.js";
import { BookListUnSync } from "./BookListUnSync.tsx";
import Book from "./Book.ts";

function UnSyncBook() {
    const [list, setList] = useState<Array<Book> | null>(null);
    const { token, getToken } = useAuthState();
    const { book_list, book_list_updated_at, book_updated_at, getUnSyncList, updateSync } = useBookState();
    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [book_list_updated_at]);
    useEffect(() => {
        console.log("book_list_updated_at", book_list_updated_at);
        if (book_list_updated_at && book_list) {
            const list = book_list.map((item) => {
                return new Book(
                    item.id,
                    item.book_id,
                    item.accommodation_id,
                    new Date(item.start_date),
                    item.name,
                    item.person_number,
                    item.days,
                    item.price,
                    new Date(item.created_at),
                    item.payment_limit_date ? new Date(item.payment_limit_date) : null,
                    item.updated_at ? new Date(item.updated_at) : null,
                    item.is_deleted ? item.is_deleted : false,
                );
            });
            setList(list);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [book_list_updated_at]);
    useEffect(() => {
        if (token) {
            getUnSyncList(token);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    useEffect(() => {
        if (token && book_updated_at) {
            getUnSyncList(token);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [book_updated_at]);

    useEffect(() => {
        getToken();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const bookUpdateHadler = (id: string) => {
        if (token) {
            updateSync(token, id, true);
        }
    };

    return (
        <div>
            {list ? (
                <div className="toggle-pannel-header">
                    <div className="toggle-title">未同期予約</div>
                </div>
            ) : null}
            {list && token ? <BookListUnSync books={list} token={token} updateHadler={bookUpdateHadler} /> : null}
        </div>
    );
}

export default UnSyncBook;
